// A translated nested label must not erase its untranslated siblings.
function mergeTranslations(fallback, translated) {
  const result = { ...fallback };
  for (const [key, value] of Object.entries(translated)) {
    result[key] =
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      fallback[key] &&
      typeof fallback[key] === "object" &&
      !Array.isArray(fallback[key])
        ? mergeTranslations(fallback[key], value)
        : value;
  }
  return result;
}
module.exports = { mergeTranslations };
